// extracted by mini-css-extract-plugin
export var headerCell = "_3o-1";
export var loadingSpinnerContainer = "_3o-4";
export var rowWrapper = "_3o-3";
export var standaloneTable = "_3o-5";
export var table = "_3o-0";
export var white = "_3o-2";